import styled from "styled-components";

export interface Props {
  color?: string;
  width?: number;
  padding?: string;
}

export const ViewStyled = styled.div`
    background-color: #F0F0F5;
    margin-top: 20px;
    border-radius: 8px;
    padding-bottom: 6px;
    min-width: 47%;
    border-bottom: 2px;
`;

export const ViewGraphic = styled.div`
    padding: 15px 0px;
    width: 100%;
    transition: 0.2s ease-in;
    @media (max-width: 600px) {
        width:100%;
        transition: 0.2s ease-in;
    }
`;

export const TextStyled = styled.div`
    background-color: #E4E4EB;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    flex: 1;
    font-size: 24px;
    font-weight: 600;
    color: #3D3D4C;
    @media (max-width: 600px) {
        flex-direction: column;
        transition: 0.2s ease-in;
        align-items: flex-start;
    }
`;

export const ViewSquar = styled.div`
    background-color:${(props: Props) => `${props.color || '#FFF'}`};
    font-size: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    font-weight: 600;
    height: 200px;
    margin: 0px 10px;
    width: 200px;
    border-radius: 8px;
    transition: 0.2s ease-in;
    @media (max-width: 600px) {
        width:100%;
        margin: 10px 20px;
        transition: 0.2s ease-in;
    }
`;

export const ViewCardRanking = styled.div`
    background-color: #FFF;
    border-radius: 8px;
    font-size: 16px;
    color: #FFF;
    font-weight: 600;
    width: 150px;
    margin: 20px;
`;

export const TextStyledCardRanking = styled.div`
    background-color: blue;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-align: center;
    padding:${(props: Props) => `${props.padding ? props.padding : `8px`}`};
    font-size: 16px;
    font-weight: 600;
    color: #FFF;
`;

export const ViewSquarCardRanking = styled.div`
    font-size: 60px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: #3D3D4C;
    font-weight: 600;
    border-radius: 8px;
`;